import { isClearingBankPayment } from '@/lib/payments/savedPaymentMethods';
import { fastestPollInterval, getEmailDeliveryPollInterval } from '@/lib/email-delivery';
import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { paymentKeys } from '@/lib/queryKeys';
import type { PaymentRecord } from './usePayments';

export function usePayment(id: string | undefined) {
  return useApiQuery<PaymentRecord>({
    queryKey: paymentKeys.detail(id),
    enabled: Boolean(id),
    queryFn: () => apiGet<PaymentRecord>(operationsClient, `/payments/${id}`),
    // A clearing bank debit refreshes until it settles; a queued
    // bank-authorization copy refreshes until it is sent or fails.
    refetchInterval: (query) =>
      fastestPollInterval(
        query.state.data && isClearingBankPayment(query.state.data) ? 5_000 : false,
        getEmailDeliveryPollInterval(query.state.data?.achAuthorizationCopy),
      ),
    showErrorToast: false,
  });
}
